export default {
      id: "clip-usage",
      viewBox: "0 0 19 46",
      url: __webpack_public_path__ + "img/icons.svg#clip",
      toString: function () {
        return this.url;
      }
    }